// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .security-questions-bg {
  background: var(--bs-primary) url('../../assets/img/create-account-bg-wide.png');
  background-size: cover;
  position: relative;
} */

.securityQuestionsContent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--bs-white);
  padding: 30px;
  width: 100%;
  max-width: 500px;
}

.security-questions-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.content .security-questions-container {
  width: 100%;
}

.security-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  outline: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/security-questions/SecurityQuestions.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;AACZ","sourcesContent":["/* .security-questions-bg {\n  background: var(--bs-primary) url('../../assets/img/create-account-bg-wide.png');\n  background-size: cover;\n  position: relative;\n} */\n\n.securityQuestionsContent {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--bs-white);\n  padding: 30px;\n  width: 100%;\n  max-width: 500px;\n}\n\n.security-questions-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.content .security-questions-container {\n  width: 100%;\n}\n\n.security-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
